var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('h4',{attrs:{"className":"super-title mb-3"}},[_vm._v("小紅帽的家")]),_vm._v(" "),_c('div',{staticClass:"d-grid"},_vm._l((_vm.datas),function(item,index){return _c('div',{key:item.id},[_c('Card',{attrs:{"index":index,"title":item.title,"category":item.category,"content":item.content,"date":item.date}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f15f6c3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Blog.vue
// module id = null
// module chunks = 